// extracted by mini-css-extract-plugin
export default {"book":"MediaMessage_book__Vk-qu","game":"MediaMessage_game__lHwbn","show":"MediaMessage_show__vX0ah"};